<div class="otp-verification-container">
    <!-- Alert Messages -->
    <div class="alert alert-error" *ngIf="state.errorMessage">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {{ state.errorMessage }}
    </div>

    <div class="alert alert-success" *ngIf="state.successMessage">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        {{ state.successMessage }}
    </div>

    <!-- Sending OTP State -->
    <div class="sending-otp-state" *ngIf="state.isSendingOtp">
        <div class="spinner-small"></div>
        <span>Sending OTP...</span>
    </div>

    <!-- OTP Form -->
    <div class="otp-form" *ngIf="state.otpSent && !state.isSendingOtp">
        <div class="form-group">
            <label for="otp-input" class="form-label">Enter OTP</label>
            <input type="text" id="otp-input" class="otp-input" [(ngModel)]="state.otp" (input)="onOtpInput($event)"
                placeholder="Enter OTP" maxlength="8" [disabled]="state.isLoading" autocomplete="off">
        </div>

        <div class="otp-actions">
            <button class="btn-resend" (click)="resendOtp()"
                [disabled]="state.resendCountdown > 0 || state.isResending">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span *ngIf="state.resendCountdown > 0">Resend in {{ state.resendCountdown }}s</span>
                <span *ngIf="state.resendCountdown === 0 && !state.isResending">Resend OTP</span>
                <span *ngIf="state.isResending">Resending...</span>
            </button>

            <button class="btn-verify" (click)="verifyOtp()" [disabled]="state.isLoading || state.otp.length < 4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    *ngIf="!state.isLoading">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div class="spinner-small" *ngIf="state.isLoading"></div>
                <span>{{ state.isLoading ? 'Verifying...' : 'Verify OTP' }}</span>
            </button>
        </div>
    </div>
</div>